/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CaseItemType = zod.enum(['text', 'image']);

export type CaseItemType = zod.input<typeof CaseItemType>;
export type CaseItemTypeOutput = zod.output<typeof CaseItemType>;
